// extracted by mini-css-extract-plugin
export default {"list":"o83xL_list","item":"nbxKx_item","icon":"xgNgl_icon","text":"Dn2xE_text","sub-title":"DI2_O_sub-title","content":"asKSW_content"};